import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { AppThunk } from 'store'
import { createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { runSurveyPlayer, playerClose } from 'core/staIntegration/slices/staLegacyPlayer'
import { getSurveyDetails } from 'modules/activityDetails/SurveyDetails/api/surveyDetailsService'
import { SurveyDetailsState, ApiSurveyDetailsResponse } from './types'

const initialState: SurveyDetailsState = {
  surveyDetailsData: {},
  forceReload: false,
}

const surveyDetailsSlice = createSlice({
  name: 'surveyDetails',
  initialState,
  reducers: {
    surveyDetailsLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiSurveyDetailsResponse>>
    ) {
      state.surveyDetailsData = action.payload
      state.forceReload = false
    },
    clearSurveyDetails(state) {
      state.surveyDetailsData = initialState.surveyDetailsData
    },
  },
  extraReducers: builder => {
    builder
      .addCase(userLoggedOut, () => {
        return initialState
      })
      .addCase(playerClose, state => {
        state.forceReload = true
        return state
      })
  },
})

const { surveyDetailsLoaded, clearSurveyDetails } = surveyDetailsSlice.actions

export { clearSurveyDetails }
export default surveyDetailsSlice.reducer

export const loadSurveyDetailsData = (surveyId: Guid, resultId?: Guid) => {
  return createApiAction({
    apiCalls: {
      surveyDetails: () => getSurveyDetails(surveyId, resultId),
    },
    payloadAction: surveyDetailsLoaded,
  })
}

export const reloadSurveyDetailsData = (surveyId: Guid, resultId?: Guid) => {
  return createApiAction({
    apiCalls: {
      surveyDetails: () => getSurveyDetails(surveyId, resultId),
    },
    payloadAction: surveyDetailsLoaded,
    shouldShowGlobalLoading: true,
    shouldCallApi: ({ surveyDetails }) => !surveyDetails.surveyDetailsData.isLoading,
    getResultToKeep: ({ surveyDetails }) => surveyDetails.surveyDetailsData.result,
  })
}

export const openSurvey =
  (surveyId: Guid, courseRevisionId: Guid): AppThunk =>
  async dispatch => {
    dispatch(runSurveyPlayer(surveyId, courseRevisionId))
  }
